<template>
  <v-card>
    <v-card-title>회원정보 확인/수정</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col>
              <h2>로그인 ID : {{ item.loginId }}</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="item.name"
                :rules="notEmptyValidation"
                label="이름"
                type="text"
                required/>
            </v-col>
            <v-col>
              <v-text-field
                v-model="item.email"
                :rules="emailValidation"
                label="이메일"
                type="text"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="item.fullAddress"
                label="주소"
                type="text"/>
            </v-col>
            <v-col cols="2">
              <v-btn color="primary" class="ma-2" @click="openAddressSearchService">
                주소 검색
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="item.mobilePhone"
                :rules="notEmptyValidation"
                label="휴대폰번호"
                type="text"
                required/>
            </v-col>
            <v-col>
              <v-text-field
                v-model="item.phone"
                label="전화번호"
                type="text"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-switch
                v-model="item.smsReceive"
                label="SMS 수신"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                label="회원등급"
                :value="printUserLevel(item.userLevel)"
                type="text"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="item.explanatoryNote"
                label="비고"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn text color="error" @click="updateUser(item)">확인</v-btn>
      <v-btn text @click="dialog.updateDialog = false">취소</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'updateMyAccountDialog',
    props: {
      item: {
        type: Object,
        required: true
      },
      dialog: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        users: [],
        search: '',
        notEmptyValidation: [
          value => !!value || '필수 값입니다'
        ],
        emailValidation: [
          value => !value || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || '유효한 이메일값이어야 합니다.'
        ],
        userLevelItems: [
          {text: '최고 관리자', value: 'SUPER_ADMINISTRATOR', level: 99},
          {text: '본사 관리자', value: 'HEADQUARTERS_MANAGER', level: 4},
          {text: '대리점 관리자', value: 'AGENCY_MANAGER', level: 3},
          {text: '관공서 관리자', value: 'PUBLIC_OFFICE_MANAGER', level: 2},
          {text: '마을 관리자', value: 'TOWN_MANAGER', level: 1}
        ],
      }
    },
    methods: {
      printUserLevel(userLevel) {
        return this.userLevelItems
          .find(userLevelElement => userLevelElement.value === userLevel)
          .text;
      },
      updateUser(user) {
        const retryFuncBackup = this.updateUser.bind(this, user);

        if (!this.$refs.form.validate()) {
          return;
        }

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/users/${encodeURI(user.loginId)}`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          }
        };

        axios.put(targetUri, user, config)
          .then(result => {
            this.popupAlert('회원 정보 업데이트 성공', 'green');
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401 && "TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
              this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
              return;
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
            this.dialog.updateDialog = false;
            this.refreshUsers();
          });
      },
      updateAddress(address) {
        this.item.fullAddress = address;
      },
      openAddressSearchService() {
        const bindedUpdateAddress = this.updateAddress.bind(this);

        new daum.Postcode({
          oncomplete: function(data) {
            console.dir(data);
            const selectedAddress = data.userSelectedType === 'R' ? data.roadAddress : data.jibunAddress;

            bindedUpdateAddress(selectedAddress);
          }
        }).open();
      },
      printDebugLog(target) {
        console.dir(target);
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      },
      refreshUsers() {
        this.$bus.$emit('refreshUsers');
      }
    },
  }
</script>